import MenuHeader from "../../common/MenuHeader"
import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const Station = (props: Props) => {
  return (
    <SetUpLayout
      title='Station'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }}
      />}
    >
      <LayoutMain />
    </SetUpLayout>
  )
}

export default Station